import { render, staticRenderFns } from "./Calculo.vue?vue&type=template&id=32d48d43&scoped=true&"
import script from "./Calculo.vue?vue&type=script&lang=js&"
export * from "./Calculo.vue?vue&type=script&lang=js&"
import style0 from "./Calculo.vue?vue&type=style&index=0&id=32d48d43&lang=scss&scoped=true&"
import style1 from "./Calculo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d48d43",
  null
  
)

export default component.exports